export var ADD_ROW_REQUEST = 'app/DatasetRow/ADD_ROW_REQUEST';
export var ADD_ROW_SUCCESS = 'app/DatasetRow/ADD_ROW_SUCCESS';
export var ADD_ROW_FAILURE = 'app/DatasetRow/ADD_ROW_FAILURE';
export var EDIT_ROW_REQUEST = 'app/DatasetRow/EDIT_ROW_REQUEST';
export var EDIT_ROW_SUCCESS = 'app/DatasetRow/EDIT_ROW_SUCCESS';
export var EDIT_ROW_FAILURE = 'app/DatasetRow/EDIT_ROW_FAILURE';
export var GET_DATASET_DATA_REQUEST = 'app/DatasetRow/GET_DATASET_DATA_REQUEST';
export var GET_DATASET_DATA_SUCCESS = 'app/DatasetRow/GET_DATASET_DATA_SUCCESS';
export var GET_DATASET_DATA_FAILURE = 'app/DatasetRow/GET_DATASET_DATA_FAILURE';
export var GET_ROW_DATA_REQUEST = 'app/DatasetRow/GET_ROW_DATA_REQUEST';
export var GET_ROW_DATA_SUCCESS = 'app/DatasetRow/GET_ROW_DATA_SUCCESS';
export var GET_ROW_DATA_FAILURE = 'app/DatasetRow/GET_ROW_DATA_FAILURE';
export var CLEAR_ROW_DATA_SUCCESS = 'app/DatasetRow/CLEAR_ROW_DATA_SUCCESS';
export var LOAD_FILES_REQUEST = 'src/GFXEditor/LOAD_FILES_REQUEST';
export var LOAD_FILES_SUCCESS = 'src/GFXEditor/LOAD_FILES_SUCCESS';
export var LOAD_FILES_FAILURE = 'src/GFXEditor/LOAD_FILES_FAILURE';
